<template>
  <teleport to="#section-reports">

    <div id="my-info">
      <button
        class="not-print float-left"
        @click="
            (e) =>
              html_to_excel_helper.export(
              e.target,
              'vehicle-operation-template-content',
              'Сводный отчет по эксплуатации ТС',
              'landscape',
            )
        "
      >
        Экспорт&nbsp;в&nbsp;EXCEL
      </button>

      <button 
        @click="printElement"
      >
        Сохранить в PDF
      </button>
    </div>
    <div
      class="temlate-report"
      id="vehicle-operation-template-content"
    >
      <div data-excelsheet="Сводный отчет по эксплуатации ТС"></div>
      <h6 class="footer-desc text-center font-weight-bold">
        Сводный отчет по эксплуатации ТС 
      </h6>
      <h6 class="footer-desc text-center font-weight-bold">
        за период с {{ getStartTime() }} по {{ getEndTime() }}
      </h6>
      <p class="text-center excel-bottom-indent">
        Отчет сформирован {{ formatTimeHelper2(new Date()) }}
      </p>

      <!-- Таблица с данными по объектам -->
      <table class="table-2 table-striped">
        <thead>
          <tr>
            <th colspan="2">Автомобиль</th>
            <th colspan="6">VIN / гос. номер</th>
            <th colspan="2">Общий пробег а/м на конец периода, км</th>
            <th colspan="2">Наработка ДВС на конец периода, м/часов</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in (props.data?.data || [])" :key="item?.id">
            <td colspan="2">{{ item?.data?.objConf?.name || 'N/A' }}</td>
            <td colspan="6">{{ item?.data?.objConf?.vin || 'N/A' }} / {{ item?.data?.objConf?.state_number || 'N/A' }}</td>
            <td colspan="2">{{ item ? getSumDistance(item) : '0.0' }}</td>
            <td colspan="2">{{ item ? getSumMotoengine(item) : '0.0' }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Highcharts графики -->
      <div class="charts-container" :class="{'mw-unset jc-center': hasChartsMore900pixels}">
        <div ref="chartContainer1" class="chart-wrapper chartContainer1" :class="{'mw-unset of-unset flex-unset': hasChartsMore900pixels}" data-excelcolspan="4"></div>
        <div ref="chartContainer2" class="chart-wrapper chartContainer2" :class="{'mw-unset of-unset flex-unset': hasChartsMore900pixels}" data-excelcolspan="4"></div>
        <div ref="chartContainer3" class="chart-wrapper chartContainer3" :class="{'mw-unset of-unset flex-unset': hasChartsMore900pixels}" data-excelcolspan="4"></div>
      </div>

      <!-- Highcharts графики -->
      <div class="charts-container" :class="{'mw-unset jc-center': hasChartsMore900pixels}">
        <div ref="chartContainer4" class="chart-wrapper chartContainer4" :class="{'mw-unset of-unset flex-unset': hasChartsMore900pixels}" data-excelcolspan="6"></div>
        <div ref="chartContainer5" class="chart-wrapper chartContainer5" :class="{'mw-unset of-unset flex-unset': hasChartsMore900pixels}" data-excelcolspan="6"></div>
      </div>
      <div class="charts-container" :class="{'mw-unset jc-center': hasChartsMore900pixels}">
        <div ref="chartContainer6" class="chart-wrapper chartContainer6" :class="{'mw-unset of-unset flex-unset': hasChartsMore900pixels}" data-excelcolspan="12"></div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref, nextTick, watch, onMounted, onBeforeUnmount } from 'vue';
// import TableTemplate from '@/App/TemplateComponents/CriticalViolations/tables/TableTemplate.vue';
import { formatTimeHelper2, formatTimeHelper3, myRoundNumber_helper } from '@/helpers/main_helper';
import { html_to_excel_helper } from '@/helpers/html_to_excel_helper';

const printElement = () => {
  window.print();
};

// Проверяем доступность Highcharts
const Highcharts = window.Highcharts;

const props = defineProps({
  trigger: { type: Boolean, required: true },
  form_desc: { type: Object },
  data: { type: Object, default: () => ({}) },
  areaId: { type: String },
});

const emit = defineEmits(['close']);

const chartContainer1 = ref(null);
const chartContainer2 = ref(null);
const chartContainer3 = ref(null);
const chartContainer4 = ref(null);
const chartContainer5 = ref(null);
const chartContainer6 = ref(null);
let chartInstances = [null, null, null, null, null, null];

const hasChartsMore900pixels = ref(false);

watch(() => props.data, () => {
  if (Highcharts) {
    nextTick(() => {
      initCharts();
    });
  }
}, { deep: true });

const getStartTime = () => {
  if (!props.data) return;
  const lastData = props.data?.data;
  if (!Array.isArray(lastData) || lastData.length < 1) return;

  // Находим элемент с максимальной длиной posArray
  const itemWithMaxPosArray = lastData.reduce((maxItem, currentItem) => {
    const currentLength = currentItem?.data?.posArray?.length || 0;
    const maxLength = maxItem?.data?.posArray?.length || 0;
    return currentLength > maxLength ? currentItem : maxItem;
  }, null);

  // Если не нашли подходящего элемента или posArray пуст
  if (!itemWithMaxPosArray?.data?.posArray?.length) return;

  const firstPos = itemWithMaxPosArray.data.posArray[0];
  const lastTime = firstPos?.interval_begin;
  if (lastTime == null) return;

  return formatTimeHelper2(new Date(lastTime * 1000), false);
};
const getEndTime = () => {
  if (!props.data) return;
  const lastData = props.data?.data;
  if (!Array.isArray(lastData) || lastData.length < 1) return;

  // Находим элемент с максимальной длиной posArray
  const itemWithMaxPosArray = lastData.reduce((maxItem, currentItem) => {
    const currentLength = currentItem?.data?.posArray?.length || 0;
    const maxLength = maxItem?.data?.posArray?.length || 0;
    return currentLength > maxLength ? currentItem : maxItem;
  }, null);

  // Проверяем, что такой элемент найден и у него есть posArray
  if (!itemWithMaxPosArray?.data?.posArray?.length) return;

  // Берём последний элемент из его posArray
  const lastPos = itemWithMaxPosArray.data.posArray[itemWithMaxPosArray.data.posArray.length - 1];
  const lastTime = lastPos?.interval_end;
  if (lastTime == null) return;

  return formatTimeHelper2(new Date(lastTime * 1000), true);
};

const getSumDistance = (item) => {
  // return item.data.posArray.reduce((acc, item) => acc + item.sumPositions.sum_distance, 0);
  if (item.data.end_distance < 0) return 'н/д'
  return item.data.end_distance.toFixed(1)
}

const getSumMotoengine = (item) => {
  // return item.data.posArray.reduce((acc, item) => acc + item.sumPositions.sum_motoengine, 0);
  if (item.data.end_motoengine < 0) return 'н/д'
  return item.data.end_motoengine.toFixed(1)
}

const createChartViolationsData = (fieldName) => {
  // Используем props.data или тестовые данные
  const currentData = props; //testData;
  const items = currentData?.data?.data || [];
  
  if (!items.length) return { categories: [], series: [] };
  
  // берем индекс с макс значением posArray, поскольку могут быть item[i] с неполными или отсутствующими данными
  const maxPosArrayIndex = items.reduce((maxIndex, item, index) => {
    const currentLength = item?.data?.posArray?.length || 0;
    const maxLength = items[maxIndex]?.data?.posArray?.length || 0;
    return currentLength > maxLength ? index : maxIndex;
  }, 0);

  const posArrayLength = items[maxPosArrayIndex]?.data?.posArray?.length || 0;
  
  if (posArrayLength === 0) return { categories: [], series: [] };
  
  const series = items.map(item => {
    const data = [];
    if (item.data?.posArray) {
      item.data.posArray.forEach((pos, index) => {
        if (pos?.sumPositions?.[fieldName] !== undefined) {
          data.push(pos.sumPositions[fieldName]);
        } else {
          data.push(0); // если данные отсутствуют
        }
      });
    }
    const name = item.data?.objConf?.name || `Объект ${item.id}`;
    return { name, data };
  });
  
  const categories = [];
  if (items[maxPosArrayIndex]?.data?.posArray) {
    items[maxPosArrayIndex].data.posArray.forEach((pos, index) => {
      if (pos?.interval_end) {
        const date = new Date(pos.interval_begin * 1000);
        categories.push(formatTimeHelper3(date));
      }
    });
  } else {
    for (let i = 0; i < posArrayLength; i++) {
      categories.push(`Колонка ${i + 1}`);
    }
  }
  
  return {
    categories,
    series
  };
}

const createChartData = (fieldName) => {
  // if (fieldName == 'sum_canexpence') { // расход топлива на 100 км
  //   console.log("Начинаю расчет расхода топлива на 100 км");
  // }
  // if (fieldName == 'sum_avgspd') { // средней скорости
  //   console.log("Начинаю расчет средней скорости");
  // }
  const currentData = props; //testData;
  const items = currentData?.data?.data || [];
  
  if (!items.length) return { categories: [], data: [] };
  
  // берем индекс с макс значением posArray, поскольку могут быть item[i] с неполными или отсутствующими данными
  const maxPosArrayIndex = items.reduce((maxIndex, item, index) => {
    const currentLength = item?.data?.posArray?.length || 0;
    const maxLength = items[maxIndex]?.data?.posArray?.length || 0;
    return currentLength > maxLength ? index : maxIndex;
  }, 0);

  const posArrayLength = items[maxPosArrayIndex]?.data?.posArray?.length || 0;
  
  if (posArrayLength === 0) return { categories: [], data: [] };
  
  const sums = new Array(posArrayLength).fill(0);
  const sums2 = new Array(posArrayLength).fill(0);
  
  items.forEach(item => {
    if (item.data?.posArray) {
      item.data.posArray.forEach((pos, index) => {
        if (pos?.sumPositions?.[fieldName] !== undefined) {
          if (fieldName == 'sum_canexpence') { // расход топлива на 100 км
            if (+pos?.sumPositions?.['sum_motoenginespd'] > 0) { // Работа двс на > 0 км/ч
              sums[index] += (+pos.sumPositions['sum_distance']);
              sums2[index] += (+pos.sumPositions['sum_canexpence']);
              // console.log(`${index} группа, в сумму растояний прибавили + ${(+pos.sumPositions['sum_distance'])}. Итого ${sums[index]}`);
              // console.log(`${index} группа, в расхода топлива прибавили + ${(+pos.sumPositions['sum_canexpence'])}. Итого ${sums2[index]}`);
            }
          } else {
            sums[index] += myRoundNumber_helper(pos.sumPositions[fieldName], 2);
          }
        } else if (fieldName == 'sum_avgspd') { // средняя скорость
          if (+pos?.sumPositions?.['sum_motoenginespd'] > 0) {
            sums[index] += (+pos.sumPositions['sum_distance']);
            sums2[index] += (+pos.sumPositions['sum_motoenginespd']);
            // console.log(`${index} группа, в сумму растояний прибавили + ${(+pos.sumPositions['sum_distance'])}. Итого ${sums[index]}`);
            // console.log(`${index} группа, в сумму времени в движении прибавили + ${(+pos.sumPositions['sum_motoenginespd'])}. Итого ${sums2[index]}`);
          } 
        }
      });
    }
  });

  if (items.length > 0 && ['sum_avgspd', 'sum_canexpence'].indexOf(fieldName) !== -1) { // средняя скорость и расход топлива на 100км
    sums.forEach((item, index) => { // вместо суммы получаем среднее значение
      // sums[index] = myRoundNumber_helper(item/items.length, 2); 
      if (fieldName == 'sum_avgspd') {
        if (sums2[index] > 0) {
          const res = (sums[index]) / (sums2[index]);
          // console.log(`${index} группа, расстояние делим на время, итого ${res}`);
          sums[index] = myRoundNumber_helper(res, 2);
        } else {
          sums[index] = 0
          // console.log(`${index} группа, время = 0, итого ${sums[index]}`);
        }
      }
      if (fieldName == 'sum_canexpence') {
        if (sums[index] > 0) {
          const res = (100 * sums2[index]) / (sums[index]);
          // console.log(`${index} группа, (100 * расход топлива) делим на расстояние, итого ${res}`);
          sums[index] = myRoundNumber_helper(res, 2);
        } else {
          sums[index] = 0
          // console.log(`${index} группа, время = 0, итого ${sums[index]}`);
        }
      }
    });
  }
  
  const categories = [];
  if (items[maxPosArrayIndex]?.data?.posArray) {
    items[maxPosArrayIndex].data.posArray.forEach((pos, index) => {
      if (pos?.interval_begin) {
        const date = new Date(pos.interval_begin * 1000);
        categories.push(formatTimeHelper3(date));
      }
    });
  } else {
    for (let i = 0; i < posArrayLength; i++) {
      categories.push(`Колонка ${i + 1}`);
    }
  }
  
  return {
    categories,
    data: sums
  };
};

const calculateChartWidth = (categories, data, chartName) => {  
  let baseWidth = 275;
  if (['sum_motoengine', 'critical_violations_cnt1'].includes(chartName)) {
    baseWidth = 412;
  }
  if ('critical_violations_cnt2'.includes(chartName)) {
    baseWidth = 825;
  }

  if (!categories) return baseWidth;
  
  const categoryCount = categories.length;
  
  let maxValue = 0;
  if (data && Array.isArray(data)) {
    if (data.length > 0) {
      if (typeof data[0] === 'object' && data[0].data) {
        const allValues = [];
        data.forEach(series => {
          if (Array.isArray(series.data)) {
            allValues.push(...series.data.filter(val => val !== undefined && val !== null));
          }
        });
        maxValue = allValues.length > 0 ? Math.max(...allValues) : 0;
      } else {
        maxValue = Math.max(...data.filter(val => val !== undefined && val !== null));
      }
    }
  }

  const distanceBetweenCategories = (String(maxValue).length * 10) / 1.2;

  if (categoryCount > 0) {
    baseWidth = Math.max(baseWidth, categoryCount * distanceBetweenCategories);
  }

  if (['sum_distance', 'sum_avgspd', 'sum_canexpence'].includes(chartName) && baseWidth > 275) {
    hasChartsMore900pixels.value = true
  }

  if (['sum_motoengine', 'critical_violations_cnt1'].includes(chartName) && baseWidth > 412) {
    hasChartsMore900pixels.value = true
  }
  if (['critical_violations_cnt2'].includes(chartName) && baseWidth > 825) {
    hasChartsMore900pixels.value = true
  }
  
  return baseWidth
};

const initCharts = () => {
  if (!Highcharts || !chartContainer1.value || !chartContainer2.value || !chartContainer3.value) return;
  
  chartInstances.forEach((instance, index) => {
    if (instance) {
      instance.destroy();
      chartInstances[index] = null;
    }
  });
  
  const chartData1 = createChartData('sum_distance');
  const chartWidth1 = calculateChartWidth(chartData1.categories, chartData1.data, 'sum_distance');
  
  chartInstances[0] = Highcharts.chart(chartContainer1.value, {
    chart: {
      type: 'column',
      width: chartWidth1
    },
    title: {
      text: `Пробег общий, км`
    },
    xAxis: {
      categories: chartData1.categories,
      crosshair: true
    },
    yAxis: {
      visible: false // убираем шкалу слева
    },
    tooltip: {
      enabled: false // Убираем tooltip
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false // Отключаем кнопку настроек графика
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        dataLabels: { // Добавляем подписи над колонками
          enabled: true,
          allowOverlap: true,
          color: '#000000', // Черный цвет
          format: '{y:.1f}', // Формат отображения значений
          style: {
            fontSize: '14px',
            fontWeight: 'bold'
          }
        }
      }
    },
    series: [{
      data: chartData1.data
    }],
    credits: {
      enabled: false
    }
  });
  
  const chartData2 = createChartData('sum_avgspd');
  const chartWidth2 = calculateChartWidth(chartData2.categories, chartData2.data, 'sum_avgspd');
  
  chartInstances[1] = Highcharts.chart(chartContainer2.value, {
    chart: {
      type: 'column',
      width: chartWidth2
    },
    title: {
      text: `Средняя скорость, км/ч`
    },
    xAxis: {
      categories: chartData2.categories,
      crosshair: true
    },
    yAxis: {
      visible: false 
    },
    tooltip: {
      enabled: false 
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false 
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        dataLabels: { 
          enabled: true,
          allowOverlap: true,
          color: '#000000', 
          format: '{y:.1f}',
          style: {
            fontSize: '14px',
            fontWeight: 'bold'
          }
        }
      }
    },
    series: [{
      data: chartData2.data
    }],
    credits: {
      enabled: false
    }
  });
  
  const chartData3 = createChartData('sum_canexpence');
  const chartWidth3 = calculateChartWidth(chartData3.categories, chartData3.data, 'sum_canexpence');
  
  chartInstances[2] = Highcharts.chart(chartContainer3.value, {
    chart: {
      type: 'column',
      width: chartWidth3
    },
    title: {
      text: 'Расход топлива, л/100 км'
    },
    xAxis: {
      categories: chartData3.categories,
      crosshair: true
    },
    yAxis: {
      visible: false 
    },
    tooltip: {
      enabled: false 
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false 
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        dataLabels: { 
          enabled: true,
          allowOverlap: true,
          color: '#000000', 
          format: '{y:.1f}',
          style: {
            fontSize: '14px',
            fontWeight: 'bold'
          },
        }
      }
    },
    series: [{
      data: chartData3.data
    }],
    credits: {
      enabled: false
    }
  });

  const chartData4_1 = createChartData('sum_motoengine'); // наработка
  const chartData4_2 = createChartData('sum_specificidling'); // холостой ход
  const chartWidth4 = calculateChartWidth(chartData4_1.categories, chartData4_1.data, 'sum_motoengine');
  
  chartInstances[3] = Highcharts.chart(chartContainer4.value, {
    chart: {
      type: 'column',
      width: chartWidth4
    },
    title: {
      useHTML: true,
      text: 'Наработка, м/ч; <span style="color: red;">Работа ДВС на хх, мч</span>'
    },
    xAxis: {
      categories: chartData4_1.categories,
      crosshair: true
    },
    yAxis: {
      visible: false 
    },
    tooltip: {
      enabled: false 
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false 
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        pointPadding: 0.2,
        borderWidth: 0,
        dataLabels: {
          enabled: false  // Отключаем глобальные dataLabels — будем настраивать индивидуально
        }
      }
    },
    series: [{
      name: 'Наработка, м/ч',
      data: chartData4_1.data,
      dataLabels: {
        enabled: true,
        allowOverlap: true,
        color: '#000000',
        format: '{y:.1f}',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        },
        verticalAlign: 'top',   // Метка будет сверху столбца
        y: -25
      }
    }, {
      name: 'Работа ДВС на хх, мч',
      data: chartData4_2.data,
      color: 'red',
      dataLabels: {
        enabled: true,
        allowOverlap: true,
        color: '#000000',
        format: '{y:.1f}',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        },
      }
    }],
    credits: {
      enabled: false
    }
  });

  const chartData5 = createChartData('critical_violations_cnt');
  const chartWidth5 = calculateChartWidth(chartData5.categories, chartData5.data, 'critical_violations_cnt1');
  
  chartInstances[4] = Highcharts.chart(chartContainer5.value, {
    chart: {
      type: 'column',
      width: chartWidth5
    },
    title: {
      text: 'Критические нарушения'
    },
    xAxis: {
      categories: chartData5.categories,
      crosshair: true
    },
    yAxis: {
      visible: false 
    },
    tooltip: {
      enabled: false 
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false 
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        dataLabels: { 
          enabled: true,
          allowOverlap: true,
          color: '#000000', 
          format: '{y:.0f}',
          style: {
            fontSize: '14px',
            fontWeight: 'bold'
          } 
        }
      }
    },
    series: [{
      data: chartData5.data
    }],
    credits: {
      enabled: false
    }
  });

  const chartData6 = createChartViolationsData('critical_violations_cnt');
  const chartWidth6 = calculateChartWidth(chartData6.categories, chartData6.series, 'critical_violations_cnt2');
  
  chartInstances[5] = Highcharts.chart(chartContainer6.value, {
    chart: {
      type: 'line',
      width: chartWidth6
    },
    title: {
      text: 'Количество критических нарушений по ТС:'
    },
    xAxis: {
      categories: chartData6.categories,
      crosshair: true
    },
    yAxis: {
      visible: false 
    },
    tooltip: {
      enabled: false 
    },
    legend: {
      enabled: true
    },
    exporting: {
      enabled: false 
    },
    plotOptions: {
      line: {
        dataLabels: { // Добавляем подписи над точками
          enabled: true,
          allowOverlap: true,
          color: '#000000', 
          format: '{y:.0f}',
          style: {
            fontSize: '14px',
            fontWeight: 'bold'
          } 
        },
        enableMouseTracking: false
      }
    },
    series: chartData6.series,
    credits: {
      enabled: false
    }
  });
};

onMounted(() => {
  buttonDone()
  clearScreen();
  displayTemplate()
});

onBeforeUnmount(() => {
  chartInstances.forEach((instance, index) => {
    if (instance) {
      instance.destroy();
      chartInstances[index] = null;
    }
  });
});

const buttonDone = () => {
  const button = document.getElementById('get-template-button');
  const targetSpan = getNeighborByClass_helper(button, 'target-show-span');
  if (!button || !targetSpan) return;
  targetSpan.innerHTML = 'Отчет выполнен';
  setElementColor_helper(button, 'green');
}

const displayTemplate = async () => {

  await nextTick();

  if (Highcharts && props.data && props.data.data) {
    initCharts();
  }
};

const clearScreen = () => {
  // удаляет только тест "Получен ответ 1 из 1 (100%)"
  const el = document.getElementById('section-reports');
  // templateContentElement.innerHTML = '';

  for (let i = el.childNodes.length - 1; i >= 0; i--) {
    const node = el.childNodes[i];
    // Если это текстовый узел — удаляем
    if (node.nodeType === Node.TEXT_NODE) {
      el.removeChild(node);
    }
  }
}
</script>

<style lang="scss" scoped>

.mw-unset {
  max-width: unset !important;
}

.of-unset {
  overflow: unset !important;
}

.flex-unset {
  flex: unset !important;
}

.jc-center {
  justify-content: center !important;
}

.table-2 {
  width: 900px !important;
  min-width: unset;
  margin: 0 auto;
  margin-bottom: 20px;
}

.charts-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.chart-wrapper {
  flex: 1;
  height: 350px;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  &.chartContainer1,
  &.chartContainer2,
  &.chartContainer3 {
    max-width: 275px;
  }

  &.chartContainer4,
  &.chartContainer5{
    max-width: 412.5px;
  }

  &.chartContainer6{
    max-width: 825px;
  }

  flex-shrink: 1;
  flex-basis: 0; 
}

@media print {
  body * {
    visibility: hidden !important;
  }
  .toasts * {
    visibility: hidden !important;
  }
  #vehicle-operation-template-content,
  #vehicle-operation-template-content * {
    visibility: visible !important;
  }
  .charts-container {
    page-break-inside: avoid;
    // margin-bottom: 20mm;
  }
  #vehicle-operation-template-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    // overflow: visible;
    // padding: 20mm; 
  }

  
}
</style>